import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  key: string = 'raise-an-exception'

  constructor(public hs: HttpService, public gs: GlobalService) { }
  async add(value: any) {
    try {
      delete value.id;
      let response = await this.hs.post(`/evaluation/raise-an-exception`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async draft(value: any) {
    try {
      delete value.id;
      let response = await this.hs.post(`/evaluation/save-as-draft`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async delete(id: number) {
    try {
      let response = await this.hs.delete(`/evaluation/delete-${this.key}?id=` + id, {})
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async get(id: any) {
    try {
      let response = await this.hs.get(`/evaluation/get-${this.key}?script_id=` + id, {})
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async get_list(filters: any) {
    try {
      let response = await this.hs.get(`/evaluation/get-exception-list`, filters)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async update(id: any, value: any) {
    try {
      let response = await this.hs.post(`/evaluation/update-${this.key}?id=` + id, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async update_exception(value: any) {
    try {
      let response = await this.hs.post(`/exception/update-exception`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async mark_exceptions_as_read(ids?: number[]) {
    try {
      const body: any = {};
      if (ids && ids.length > 0) body.ids = ids;
      let response = await this.hs.post(`/evaluation/mark-exception-as-read`, {}, body)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
